import { defineMessages } from 'react-intl';

export default defineMessages({
  mergedPullRequestStateMessage: {
    id: 'frontbucket.repository.pullRequest.mergedPullRequestStateMessage',
    description:
      'Text displayed in the section message for a merged pull request',
    defaultMessage: 'Merged pull request',
  },
  declinedPullRequestStateMessage: {
    id: 'frontbucket.repository.pullRequest.declinedPullRequestStateMessage',
    description:
      'Text displayed in the section message for a declined pull request',
    defaultMessage: 'Declined pull request',
  },
  readyToMergePullRequestStateMessage: {
    id: 'frontbucket.repository.pullRequest.readyToMergePullRequestStateMessage',
    description:
      'Text displayed in the section message for a ready to merge pull request',
    defaultMessage: 'This pull request is ready to merge',
  },
  commitAuthorKey: {
    id: 'frontbucket.repository.pullRequest.commitAuthorKey',
    description: 'The user that authored the changes in the commit',
    defaultMessage: 'Author: {author}',
  },
  commitClosedByKey: {
    id: 'frontbucket.repository.pullRequest.commitClosedByKey',
    description: 'The user that applied the changes in the commit',
    defaultMessage: 'Closed by: {closedBy}',
  },
  readyToMergePullRequestDescriptionWithChecks: {
    id: 'frontbucket.repository.pullRequest.readyToMergePullRequestDescriptionWithChecks',
    description: 'Description for ready to merge state message with checks',
    defaultMessage:
      'All of the {required} pre-merge checks have passed. {onMergeChecksDescription}',
  },
  required: {
    id: 'frontbucket.repository.pullRequest.state-message.required',
    description: 'Text for required',
    defaultMessage: 'required',
  },
  readyToMergePullRequestOnMergeChecksDescription: {
    id: 'frontbucket.repository.pullRequest.readyToMergePullRequestOnMergeChecksDescription',
    description:
      'Description for ready to merge state message for the on-merge checks',
    defaultMessage:
      'The following {checksCount} {checksCount, plural, one {check} other {checks}} will run on merge.',
  },
  mergePullRequestLink: {
    id: 'frontbucket.repository.pullRequest.mergePullRequestLink',
    description:
      'Text for link to merge pull request in ready to merge state message',
    defaultMessage: 'Merge pull request',
  },
  asyncMergePullRequestStateMessage: {
    id: 'frontbucket.repository.pullRequest.asyncMergeSection.title',
    description:
      'Text to display as a title of the async merge section message',
    defaultMessage: 'Merge in progress',
  },
  asyncMergePullRequestFailureStateMessage: {
    id: 'frontbucket.repository.pullRequest.asyncMergeSectionFailure.title',
    description:
      'Text to display as a title of the failed async merge section message',
    defaultMessage: 'Previous merge attempt failed',
  },
  asyncMergePullRequestOnMergeCheckFailureDescription: {
    id: 'frontbucket.repository.pullRequest.asyncMergePullRequestOnMergeCheckFailureDescription',
    description: 'Description for async merge failed due to on-merge checks',
    defaultMessage:
      'The following on-merge {total, plural, one {check has} other {checks have}} failed which stopped your pull request from being merged. Resolve any issues before you attempt another merge.',
  },
  asyncPullRequestDescription: {
    id: 'frontbucket.repository.pullRequest.asyncMergeSection.body',
    description: 'Text to display as a body of the async merge section message',
    defaultMessage:
      'This pull request is being merged in the background. You can safely navigate away. The status of the pull request will be updated once it is merged.',
  },
  mergeConflictMessage: {
    id: 'frontbucket.repository.pullRequest.mergeConflictSection.title',
    description:
      'Text displayed as the title of the section message for a merge conflict',
    defaultMessage: 'This pull request can’t be merged',
  },
  mergeConflictDescription: {
    id: 'frontbucket.repository.pullRequest.mergeConflictSection.body',
    description:
      'Text to display as a body of the merge conflict section message',
    defaultMessage: 'You will need to resolve conflicts to be able to merge.',
  },
  mergeConflictLearnMoreLink: {
    id: 'frontbucket.repository.pullRequest.mergeConflictSection.action',
    description: 'Action to learn more about merge conflicts',
    defaultMessage: 'Learn more',
  },
  missingCommitsPullRequestMessage: {
    id: 'frontbucket.repository.pullRequest.missingCommitsPullRequest.title',
    description:
      'Text to display as the title of the section message for an out of sync pull request',
    defaultMessage: 'Pull request is out of date',
  },
  missingCommitsPullRequestWritePermissionDescription: {
    id: 'frontbucket.repository.pullRequest.missingCommitsPullRequest.writePermissions.body',
    description:
      'Text to display as the body of the section message for an out of sync pull request for a user with write privileges',
    defaultMessage:
      'There are new commits included in the source branch. Update the pull request to view the changes.',
  },
  missingCommitsPullRequestReadPermissionDescription: {
    id: 'frontbucket.repository.pullRequest.missingCommitsPullRequest.readPermissions.body',
    description:
      'Text to display as the body of the section message for an out of sync pull request for a user with read-only privileges',
    defaultMessage: 'There are new commits included in the source branch.',
  },
  missingCommitsPullRequestLink: {
    id: 'frontbucket.repository.pullRequest.missingCommitsPullRequest.action',
    description: 'Action to update the pull request',
    defaultMessage: 'Update pull request',
  },
  updatingCommitsPullRequestMessage: {
    id: 'frontbucket.repository.pullRequest.updatingCommitsPullRequest.title',
    description:
      'Text to display as the title of the section message for a pull request updating its branch references',
    defaultMessage: 'Updating pull request',
  },
  updatingCommitsPullRequestDescription: {
    id: 'frontbucket.repository.pullRequest.updatingCommitsPullRequest.body',
    description:
      'Text to display as the body of the section message for a pull request updating its branch references',
    defaultMessage: 'This pull request is being updated in the background.',
  },
  updatingCommitsErrorPullRequestMessage: {
    id: 'frontbucket.repository.pullRequest.updatingCommitsErrorPullRequest.title',
    description:
      'Text to display as the title of the section message for a pull request erroring in updating its branch references',
    defaultMessage: 'Pull request update failed',
  },
  updatingCommitsErrorPullRequestDescription: {
    id: 'frontbucket.repository.pullRequest.updatingCommitsErrorPullRequest.body',
    description:
      'Text to display as the body of the section message for a pull request erroring in updating its branch references',
    defaultMessage:
      'There was an issue updating this pull request. Refresh the page or try again later.',
  },
  loadMergeCommitBuildsFailureTitle: {
    id: 'frontbucket.repository.pullRequest.loadMergeCommitBuildsFailureTitle',
    description: 'Title text to display when loading the build statuses fails.',
    defaultMessage: 'Oops!',
  },
  loadMergeCommitBuildsFailureDescription: {
    id: 'frontbucket.repository.pullRequest.loadMergeCommitBuildsFailureDescription',
    description:
      'Descriptive text to display when loading the build statuses fails.',
    defaultMessage: `We couldn't load commit statuses for that commit.`,
  },
  markAsReadyAction: {
    id: 'frontbucket.repository.pullRequest.markAsReady',
    description: 'Action to mark a pull request as ready.',
    defaultMessage: 'Mark as ready',
  },
  draftSectionTitle: {
    id: 'frontbucket.repository.pullRequest.draftSection.title',
    description: 'Title for the draft section message',
    defaultMessage: 'This is a draft pull request',
  },
  draftSectionBody: {
    id: 'frontbucket.repository.pullRequest.draftSection.body',
    description: 'Body for the draft section message',
    defaultMessage:
      "The work is still ongoing. The pull request cannot be merged until it's marked as ready for review.",
  },
});
